// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__3vqWd","left":"Navbar_left__5eszr","right":"Navbar_right__2zDvf"};